import '../GameRoom/GRStyle.css'
import GameRoomsCard from '../GameRoom/GameRoomsCard'
import { Link } from 'react-router-dom'
import { getStreakDetailsUrl } from '../api/urls'
import { useApiGet } from '../api/apiHooks'
import { useEffect, useState } from 'react'
import Pagination from '../Component/Pagination'
import GameRoomsCardSkeleton from '../Component/SkeletonLoaders/GameRoomsCardSkeleton'

export default function StreakDetails() {
  const [pageNo, setPageNo] = useState(1)
  const streakId = window.location.pathname.split('/')[2]

  const {
    data: StreakDetails,
    isLoading: isStreakDataLoading,
    isError,
    error,
  } = useApiGet({
    queryKey: [getStreakDetailsUrl(streakId)],
    hasPagination: true,
  })

  const setPage = (page) => {
    setPageNo(page)
  }

  useEffect(() => {
    const screenTopSection = document.getElementById('pageTitle')
    screenTopSection.scrollIntoView({ behavior: 'smooth', alignToTop: true })
  }, [pageNo, StreakDetails])

  // console.log('StreakDetails', StreakDetails, pageNo, userId)
  return (
    <div className='cards-container'>
      <div className='row'>
        <h3 id='pageTitle' style={{ scrollMarginTop: '90px' }}>
          Streak Game Rooms
        </h3>
      </div>

      {isError ? <p style={{ color: 'red' }}>something went wrong</p> : null}
      {isStreakDataLoading && (
        <>
          {[...Array(3)].map((_, idx) => (
            <GameRoomsCardSkeleton key={idx} />
          ))}
        </>
      )}
      {StreakDetails?.data?.length === 0 && (
        <p style={{ color: 'gray' }}> No game room joined </p>
      )}

      {StreakDetails?.data?.map((item, index) => {
        return (
          <Link to={`/game-rooms/${item.id}`} key={index}>
            <GameRoomsCard
              isGR_heroSection={false}
              GRDetails={item}
              error={error}
              isError={isError}
              streakStatus={item.status}
            />
          </Link>
        )
      })}

      {!isStreakDataLoading &&
        StreakDetails?.data?.length > 0 &&
        StreakDetails?.pagination?.totalPages > 1 && (
          <Pagination
            pagination={StreakDetails?.pagination}
            setPageNo={setPage}
          />
        )}
    </div>
  )
}
